import React from 'react';
import { Spin, Typography } from 'antd';
import { useLocale } from '../../contexts/LocaleContext';
import styles from './StateViews.module.css';

const { Text } = Typography;

interface LoadingStateProps {
  tip?: string;
  fullPage?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ tip, fullPage = false }) => {
  const { locale } = useLocale();
  const defaultTip = locale === 'fa' ? 'در حال بارگذاری...' : 'Loading...';

  return (
    <div className={`${styles.container} ${fullPage ? styles.fullPage : ''}`}>
      <Spin size="large" />
      <Text type="secondary">{tip ?? defaultTip}</Text>
    </div>
  );
};

export default LoadingState;
